import { CommissionsSettingsLevel } from "../../../../modules/commissions/level/types";
import { CommissionsSettingsRank } from "../../../../modules/commissions/ranks/types";
import { formatCommissionsLevelName } from "../../../utils/formatUtils";
import { BooleanHistoryItem, DateHistoryItem, EmptyHistoryItem } from "./commonHistoryItems";

const CommissionsSettingsLevelHistoryItem = (value: CommissionsSettingsLevel) =>
  value ? <span>{formatCommissionsLevelName(value)}</span> : EmptyHistoryItem();

const CommissionsSettingsRankHistoryItem = (value: CommissionsSettingsRank) =>
  value ? <span>{value.name}</span> : EmptyHistoryItem();

export const CommissionsSettingsHistoryItemsMap = new Map<string, (value: any) => React.JSX.Element>([
  ["lastLevelChangeDate", DateHistoryItem],
  ["includeInBulkPayment", BooleanHistoryItem],
  ["useAsHead", BooleanHistoryItem],
  ["unifyPointsCalculation", BooleanHistoryItem],
  ["level", CommissionsSettingsLevelHistoryItem],
  ["rank", CommissionsSettingsRankHistoryItem]
]);
